/**
 * Editor defaults for the diff panel.
 *
 * @module
 */
import { useSettings, useUpdateSettings } from "../../hooks/useSettings";
import { Switch } from "../ui/switch";
import { SettingResetButton, SettingsRow, SettingsSection } from "./settingsLayout";
import { DEFAULT_UNIFIED_SETTINGS } from "@cmmd-forge/contracts/settings";

export function EditorSection() {
  const settings = useSettings();
  const { updateSettings } = useUpdateSettings();

  return (
    <SettingsSection id="editor" title="Editor">
      <SettingsRow
        title="Diff line wrapping"
        description="Set the default wrap state when the diff panel opens."
        resetAction={
          settings.diffWordWrap !== DEFAULT_UNIFIED_SETTINGS.diffWordWrap ? (
            <SettingResetButton
              label="diff line wrapping"
              onClick={() =>
                updateSettings({
                  diffWordWrap: DEFAULT_UNIFIED_SETTINGS.diffWordWrap,
                })
              }
            />
          ) : null
        }
        control={
          <Switch
            checked={settings.diffWordWrap}
            onCheckedChange={(checked) => updateSettings({ diffWordWrap: Boolean(checked) })}
            aria-label="Wrap diff lines by default"
          />
        }
      />

      <SettingsRow
        title="Co-author commits with Forge"
        description="Add a Co-Authored-By trailer pointing at the cmmd-forge GitHub App so commits render as 'cmmd-forge[bot] and you' on GitHub."
        resetAction={
          settings.coauthorIncludeForge !== DEFAULT_UNIFIED_SETTINGS.coauthorIncludeForge ? (
            <SettingResetButton
              label="Forge co-author"
              onClick={() =>
                updateSettings({
                  coauthorIncludeForge: DEFAULT_UNIFIED_SETTINGS.coauthorIncludeForge,
                })
              }
            />
          ) : null
        }
        control={
          <Switch
            checked={settings.coauthorIncludeForge}
            onCheckedChange={(checked) =>
              updateSettings({ coauthorIncludeForge: Boolean(checked) })
            }
            aria-label="Include Forge as commit co-author"
          />
        }
      />
    </SettingsSection>
  );
}

// ---------------------------------------------------------------------------
// Provider settings — extracted from General so /settings/providers can host
// it as a dedicated page, matching the settings information architecture the
// rest of this screen follows.
// ---------------------------------------------------------------------------
